import { useMarketplaceProjects } from '@hooks/useMarketplaceProjects';
import { Projects } from '@components/Projects';
import { Header } from '@components/Typography';
import { LoadingContent } from '@components/LoadingContent';

export function Marketplace() {
  const { data, error, isValidating } = useMarketplaceProjects();

  return (
    <>
      <Header>Marketplace</Header>
      <div className="mt-2">Earn a percentage of the revenue you generate for projects.</div>

      <LoadingContent loading={isValidating && !data} error={error}>
        <div className="mt-8">
          {data?.length ? (
            <Projects projects={data} userType="affiliate" getLink={slug => `/${slug}/sharer`} />
          ) : (
            <div>There are no projects in the marketplace at this time.</div>
          )}
        </div>
      </LoadingContent>
    </>
  );
}
